
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.086 7.155a.831.831 0 00-.163-.244l-5-5a.832.832 0 00-.245-.163c-.025-.012-.051-.019-.078-.028a.827.827 0 00-.216-.042c-.017-.002-.033-.011-.05-.011H5.5c-.919 0-1.667.747-1.667 1.666v13.334c0 .919.748 1.666 1.667 1.666h10c.92 0 1.667-.747 1.667-1.666V7.5c0-.017-.01-.033-.011-.052a.793.793 0 00-.043-.215c-.008-.027-.015-.053-.027-.078zm-2.764-.488h-2.155V4.512l2.155 2.155zm-8.822 10V3.333h5V7.5c0 .46.373.833.834.833H15.5l.002 8.334H5.5z"}}),_c('path',{attrs:{"d":"M7.167 10h6.666v1.667H7.166V10zm0 3.333h6.666V15H7.166v-1.667zm0-6.666h1.666v1.666H7.166V6.667z"}})])
          )
        }
      }
    